import React, { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { largestRect } from 'rect-scaler';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { container } from 'tsyringe';
import * as R from 'ramda';
import { Config } from '../../config';


import { ApiService } from '../../services/api-service';
import { WebRTCsdkService } from '../../services/webrtcsdk-service';

import { Producer, ProducerType } from '../../models/producerClass';
import { Layer } from '../../models/channelClass';
import { ViewType } from '../../models/layoutClass';

import ProducerLivePlayer from '../producerPlayer/ProducerLive';
import dragSwap from '../../assets/icons/icon-dragndrop-white.png';

import { IFrame } from '../layout/iFrames/iFrames';

import { getInitials, useSharedState } from '../../utils/helpers';

import { TemplateService } from '../../services/template-service';
import { Backgrounds } from './showLiveBackground';
import { Foregrounds } from './showLiveForeground';
import { ActionType, GroupType } from '../../models/actionClass';
import { SWAP_PRODUCER } from '../../redux/producers/producersReducer';
import { swapProducer } from '../../redux/producers/producersActions';


interface ProducerProps {
  producers: Producer[];
}
export const ShowProducers = React.memo(function Show({ producers }: ProducerProps) {

  const layout = useSelector((state: any) => state.layout);

  const [apiService] = useState(container.resolve(ApiService));
  const [templateService] = useState(container.resolve(TemplateService));

  const [layersCount, setLayersCount] = useState(0);

  const nametagsActive = useSelector((state: any) => state.templates.brandsettings.nametagsActive);
  const selectedTheme = useSelector((state: any) => (state.templates.brandsettings.selectedTheme || '1').replace(/lower_third/ig, ''));
  const primaryColor = useSelector((state: any) => state.templates.brandsettings.primaryColor);
  const selectedTicker = useSelector((state: any) => state.templates.selectedTicker);

  const producerAttributes = [];

  // console.log('%%%% IN SHOW PRODUCERS', producers, layout);

  const dragImg = document.createElement("img");
  dragImg.src = dragSwap;

  const layers: Layer[] = [];
  const [producerVideoIsSmall, setProducerVideoIsSmall] = useState([]);

  const dispatch = useDispatch();
  let draggedProducer = producers[0];
  let droppedProducer = producers[0];


  const computeWrapperSize = (controlsVisible) => {
    const previewDiv = document.getElementById('LivePreview');
    const wrapperDiv = document.getElementById('LivePreview-wrapper');
    const ratio = 16 / 9;

    let width = previewDiv?.clientWidth || window.innerWidth;
    let height = previewDiv?.clientHeight || window.innerHeight;
    // console.log('preview = ', width, height);

    const maxHeight = controlsVisible ? (height - 165) : (height);

    const maxHeight2 = width / ratio;
    // console.log('maxHeight', controlsVisible, maxHeight, maxHeight2);

    // TODO change here 1600 into a maximum defined by UX
    const maxWidth = 1600;
    const wrapperWidth = Math.min(maxWidth, maxHeight * ratio, maxHeight2 * ratio);
    const wrapperHeight = wrapperWidth / ratio;
    // console.log('2222', wrapperWidth, wrapperHeight);


    const marginTop = (maxHeight - wrapperHeight) / 2 - (controlsVisible ? 0 : 2.5);


    if (wrapperDiv) {
      wrapperDiv.style.setProperty('width', wrapperWidth + 'px');
      wrapperDiv.style.setProperty('height', wrapperHeight + 'px');
      if (marginTop >= 0) {
        wrapperDiv.style.setProperty('margin-top', marginTop + 'px');
      }
    }

  }

  const [spottedProducer, setSpottedProducer] = useSharedState(apiService.spottedProducer$);

  const GetWindowGeometry = (id) => {
    const div = document.getElementById(id);
    if (div) {
      return { width: div.clientWidth, height: div.clientHeight };
    }
    return { width: window.innerWidth / 4, height: window.innerHeight / 4 };
  };

  const OnDragOver = (ev, producer) => {
    if (ev) {
      ev.preventDefault();
    }
    if (producer.id !== draggedProducer.id) {
      // set border to dest producer
      clearDroppedProducer();
      droppedProducer = producer;
      const li = document.getElementById(droppedProducer.id);
      if (li) {
        li.style.setProperty('border', 'dashed 2px white');
        li.style.setProperty('transform', 'scale(0.9)');
      }
    }
  };

  const clearDroppedProducer = () => {
    const li = document.getElementById(droppedProducer.id);
    if (li) {
      li.style.setProperty('border', 'none');
      li.style.setProperty('transform', 'scale(1.0)');
    }
  };

  const OnDragStart = (ev, producer) => {
    // if (ev) {
    //   ev.preventDefault();
    // }
    draggedProducer = producer;
    droppedProducer = producer;
    // console.log('dragStart', producer.name);

    ev.dataTransfer.setDragImage(dragImg, 30, 30);
  };

  const OnDragEnd = (ev) => {
    clearDroppedProducer();
  };
  const OnDragLeave = (ev) => {
    clearDroppedProducer();
  };


  const OnDrop = (ev, producer) => {
    if (!draggedProducer || !producer) return;

    console.log('drop done: spot ', draggedProducer.name, ' onto ', producer.name);

    if (draggedProducer.id === producer.id) {
      console.log('swaps same prod !!')
      return;
    }

    const payload = { producer1: draggedProducer, producer2: producer };

    apiService.updateReason = { group: ProducerType.PRODUCER, action: ActionType.SWAP };
    dispatch(swapProducer(payload));
    apiService.swapLayers([draggedProducer.number, producer.number]);

    clearDroppedProducer();
  };


  const recalculateLayout = (sendUpdatedLayer: boolean = true) => {

    console.log('###### recalculateLayout', layout.view);

    let layersUpdated = false;
    const nametags = [];

    let viewBig = true;
    if (layout.view === ViewType.CLASSIC || layout.view === ViewType.COVER) {
      viewBig = false;
    }
    let hasGutter = true;
    if (layout.view === ViewType.COVER || layout.view === ViewType.SPLIT) {
      hasGutter = false;
    }

    // const size = GetWindowGeometry('LivePreview-viewer');
    const size = { width: 10000, height: 10000 };
    const fullSize = R.clone(size);

    // if (selectedTicker) {
    //   //  && settingService.getSetting(SettingsKey.shiftVideosUp) ) {
    //   // use only 95% of the height
    //   size.height = size.height * 0.955;
    //   // console.log('HEIGHT:', size.height, fullSize.height);
    // }


    // console.log('wsize', size);
    const ratio = size.width / size.height;

    layers.splice(0, layers.length);

    // index is also used for nametags
    let index = 0;
    if (producers.length > 0) {

      // // remove 1 if layout.view is big
      // const videoCount = producers.length - (viewBig ? 1 : 0);
      const videoCount = producers.length;

      const gutterSize = (videoCount === 1 ? 1200 : 400); // change value here to increase /decrease gutter size
      const gutter = (hasGutter ? gutterSize : 0);
      const result = largestRect(size.width, size.height - 1, videoCount, size.width, size.height);
      // console.log('best Rect', result);
      let top, left = 0;

      const gutterH = gutter * result.cols / (result.cols + 1);
      const gutterV = gutter * result.rows / (result.rows + 1);

      // name tags positions
      let ntleft, nttop = 0;

      const oldLayers = R.clone(apiService.layers$.getValue());
      // console.log('oldLayers', oldLayers);

      let isContentShared = false;
      for (const p of producers) {
        if (p.type === ProducerType.CONTENT_SHARING) {
          isContentShared = true;
          break;
        }
      }

      for (const p of producers) {
        let clipPath = { top: 0, left: 0, right: 0, bottom: 0 };
        const li = document.getElementById(p.id);
        const tag = document.getElementById('tag' + p.id);
        if (li) {

          let width = result.width - gutter;
          let height = result.height - gutter;


          if (p.isSpotted || (videoCount === 1 && p.type === ProducerType.CONTENT_SHARING)) {

            // producer is spotted
            // or only 1 prod && screen content => maximize like if spotted

            width = size.width;
            height = size.height;
            top = 0;
            left = 0;
            layersUpdated = true;

            ntleft = left + size.width * 0.01;
            nttop = size.height * 0.90;

          } else {

            if (layout.view === ViewType.CLASSIC || (videoCount === 1 && (layout.view === ViewType.CINEMA || layout.view === ViewType.SIDEBYSIDE))) {
              left = Math.floor(index % result.cols) * (width + gutterH) + gutterH;
              if (videoCount === 3 && index >= 2) {
                left += width / 2;
              }
              if (videoCount === 5 && index >= 3) {
                left += width / 2;
              }
              if ((videoCount === 7) && index == 6) {
                // 7th is shifted in the middle of screen
                left += width + gutterH;
              }
              if ((videoCount === 8) && index >= 6) {
                // 7 and 8th shifted by half width
                left += width / 2;
              }

              top = Math.floor(index / result.cols) * (height + gutterV) + gutterV;
              if (videoCount === 2 || videoCount === 5 || videoCount === 6) {
                top += height / 2 + gutterV;
              }
              height += result.rows;
              width += result.cols;

              ntleft = left + 100;
              nttop = top + height - 550;

              if (selectedTicker) {
                if ( index >= 6 ||
                  (videoCount === 3 && index == 2) ||
                  (videoCount === 4 && index >= 2)
                ) {
                  nttop -= 200;
                }
              }

            } else if (
              (layout.view === ViewType.CINEMA) ||
              (videoCount >= 6 && layout.view === ViewType.SIDEBYSIDE) ||
              (isContentShared && layout.view === ViewType.COVER) ||
              (isContentShared && layout.view === ViewType.SPLIT)
            ) {

              if (index === 0) {
                const bottomLineHeight = size.height / 4 + (selectedTicker ? 400 : 0);
                height = size.height - bottomLineHeight - 20;
                width = height;
                left = (size.width - width) / 2;
                top = 200;

                ntleft = left + 100;
                nttop = top + height - 600;

              } else {
                width = size.width / 5;   // value comes from Zeplin design
                height = width;
                if (videoCount < 6) {
                  left = (size.width / 2 - (width + 100) * (videoCount - 1) / 2) + (width + 100) * (index - 1);
                  clipPath = { top: 0, bottom: 0, left: 0, right: 0 }
                } else {
                  const rwidth = (size.width) / (videoCount);
                  left = (size.width / videoCount / 12 + rwidth) * (index - 1) + (5 - videoCount) * 180 + 500;
                  // console.log('width', width, 'rwidth', rwidth)
                  const border = (width - rwidth) / 2;
                  clipPath = { top: 5, bottom: 5, left: border * 4 + 500, right: border * 4 + 500 };
                }
                top = (size.height - height - 100) - (selectedTicker ? 400 : 0);

                ntleft = left + clipPath.left / 7 + 100;
                nttop = top + height - 500;

              }

            } else if (layout.view === ViewType.COVER ||
              (videoCount === 1 && (layout.view === ViewType.PIP || layout.view === ViewType.SPLIT)) ||
              (videoCount === 2 && layout.view === ViewType.SPLIT) ||
              (videoCount >= 6 && layout.view === ViewType.SPLIT)
            ) {

              if (videoCount === 1) {
                // 0
                left = 0;
                top = 0;
                height = size.height;
                width = size.width;
                clipPath = { top: 0, bottom: 0, left: 0, right: 0 }
              } else if (videoCount === 2) {
                // 0 - 1
                left = (index - 0.5) * (size.width / 2);
                top = 0;
                height = size.height;
                width = size.width;
                clipPath = { top: 0, bottom: 0, left: size.width / 4, right: size.width / 4 }
              } else if (videoCount === 3) {
                // 0 - 1 - 2
                left = (index - 1) * (size.width / 3);
                top = 0;
                height = size.height;
                width = size.width;
                clipPath = { top: 0, bottom: 0, left: size.width / 3, right: size.width / 3 }
              } else if (videoCount === 4) {
                // 0 - 1
                // 2 - 3

                left = (index % 2) * size.width / 2 - 10;
                top = Math.floor(index / 2) * size.height / 2 - 10;
                height = size.height / 2 + 20;
                width = size.width / 2 + 20;
                clipPath = { top: 10, bottom: 10, left: 10, right: 10 }
              } else if (videoCount === 5) {
                // 0 - 1 - 2
                //   3 - 4

                if (index < 3) {
                  left = (index - 0.25) * (size.width / 3);
                  top = 0;
                  height = size.height / 2;
                  width = size.width / 2;
                  clipPath = { top: 0, bottom: 0, left: size.width / 6, right: size.width / 6 }
                } else {
                  left = ((index - 3) % 2) * size.width / 2 - 10;
                  top = size.height / 2 - 10;
                  height = size.height / 2 + 20;
                  width = size.width / 2 + 20;
                  clipPath = { top: 10, bottom: 10, left: 10, right: 10 }
                }
              } else if (videoCount === 6) {
                // 0 - 1 - 2
                // 3 - 4 - 5

                left = ((index % 3) - 0.25) * (size.width / 3);
                top = Math.floor(index / 3) * size.height / 2;
                height = size.height / 2;
                width = size.width / 2;
                clipPath = { top: 0, bottom: 0, left: size.width / 6, right: size.width / 6 };
              } else if (videoCount === 7) {
                // 0 - 1 - 4
                //         5
                // 2 - 3 - 6
                if (index < 2) {
                  left = ((index) % 2 - 0.25) * (size.width / 3);
                  top = 0;
                  height = size.height / 2;
                  width = size.width / 2;
                  clipPath = { top: 0, bottom: 0, left: size.width / 6, right: size.width / 6 }
                } else if (index < 4) {
                  left = ((index - 2) % 2 - 0.25) * (size.width / 3);
                  top = size.height / 2;
                  height = size.height / 2;
                  width = size.width / 2;
                  clipPath = { top: 0, bottom: 0, left: size.width / 6, right: size.width / 6 }

                } else {
                  left = 2 * size.width / 3;
                  top = size.height / 3 * (index - 4);
                  height = size.height / 3;
                  width = size.width / 3;
                  clipPath = { top: 10, bottom: 10, left: 10, right: 10 }
                }
              } else if (videoCount === 8) {
                // 0 - 1 - 2 - 3
                // 4 - 5 - 6 - 7

                left = ((index % 4) - 0.5) * (size.width / 4) + 10;
                top = Math.floor(index / 4) * size.height / 2 + 10;
                height = size.height / 2 + 10;
                width = size.width / 2 + 10;
                clipPath = { top: 5, bottom: 5, left: size.width / 4, right: size.width / 4 };

              } else if (videoCount === 9) {

                // 0 - 1 - 2
                // 3 - 4 - 5
                // 6 - 7 - 8

                left = index % 3 * (size.width / 3) - 10;
                top = (size.height / 3) * Math.floor(index / 3);
                height = size.height / 3 + 10;
                width = size.width / 3 + 10;
                clipPath = { top: 10, bottom: 10, left: 10, right: 10 }

              }

              ntleft = Math.max(0, left + clipPath.left / 2) + 100;
              nttop = top + height - 600;

              if (selectedTicker) {
                if ((videoCount === 9 && index >= 6) ||
                  (videoCount === 8 && index >= 4) ||
                  (videoCount === 7 && [2, 3, 6].includes(index)) ||
                  (videoCount === 6 && index >= 3) ||
                  (videoCount === 5 && index >= 3) ||
                  (videoCount === 4 && index >= 2) ||
                  (videoCount <= 3)
                ) {
                  nttop -= 400;
                }
              }

            } else if (layout.view === ViewType.SPLIT) {

              if (index === 0) {
                left = (index - 0.5) * (size.width / 2);
                top = 0;
                height = size.height;
                width = size.width;
                clipPath = { top: 0, bottom: 0, left: size.width / 4, right: size.width / 4 }
              } else {

                if (videoCount === 3) {
                  left = size.width / 2 - 10;
                  top = (index - 1) * size.height / 2 - 10;
                  height = size.height / 2 + 20;
                  width = size.width / 2 + 20;
                  clipPath = { top: 10, bottom: 10, left: 10, right: 10 }
                } else if (videoCount === 4) {
                  if (index >= 1 && index <= 2) {
                    left = (((index + 1) % 4) - 0.5) * (size.width / 4) - 10;
                    top = Math.floor((index + 1) / 4) * size.height / 2 - 10;
                    height = size.height / 2 + 10;
                    width = size.width / 2 + 10;
                    clipPath = { top: 5, bottom: 5, left: size.width / 4 + 5, right: size.width / 4 + 5 }
                  } else {
                    left = size.width / 2 - 10;
                    top = size.height / 2 - 10;
                    height = size.height / 2 + 20;
                    width = size.width / 2 + 20;
                    clipPath = { top: 10, bottom: 10, left: 10, right: 10 };
                  }
                } else if (videoCount === 5) {
                  if (index >= 1 && index <= 2) {
                    left = (((index + 1) % 4) - 0.5) * (size.width / 4) - 10;
                    top = Math.floor((index + 1) / 4) * size.height / 2 - 10;
                  } else {
                    left = (((index - 1) % 4) - 0.5) * (size.width / 4) - 10;
                    top = size.height / 2 - 10;
                  }
                  height = size.height / 2 + 10;
                  width = size.width / 2 + 10;
                  clipPath = { top: 5, bottom: 5, left: size.width / 4 + 5, right: size.width / 4 + 5 }
                }
              }

              ntleft = Math.max(0, left + clipPath.left / 2) + 100;
              nttop = top + height - 600;

              if (selectedTicker) {
                if (
                  (videoCount >= 4 && [0,3,4].includes(index)) ||
                  (videoCount == 3 && [0,2].includes(index))
                ) {
                  nttop -= 400;
                }
              }


            } else if (layout.view === ViewType.SIDEBYSIDE) {
              if (index === 0) {
                width = size.width * 3 / 4 - 200;
                height = width;
                top = (size.height - height) / 2;
                left = 200;

                ntleft = left + 100;
                nttop = top + height - 600;

              } else {
                height = size.height / 5;   // value comes from Zeplin design
                width = height;
                if (videoCount < 6) {
                  top = (size.height / 2 - (height + 100) * (videoCount - 1) / 2) + (height + 100) * (index - 1);
                  clipPath = { top: 5, bottom: 5, left: 5, right: 5 }
                } else {
                  // this code is working ut is not because CINEMA mode is used if videoCount >= 6
                  const rheight = (size.height) / (videoCount);
                  top = (size.height / videoCount / 12 + rheight) * (index - 1) + (5 - videoCount) * 180 + 500;
                  // console.log('height', height, 'rheight', rheight)
                  const border = (height - rheight) / 2;
                  clipPath = { top: border * 4 + 500, bottom: border * 4 + 500, left: 0, right: 0 };
                }
                left = (size.width - width - 100);


                ntleft = left + clipPath.left / 10;
                nttop = top + height - 550;

              }

            } else if (layout.view === ViewType.PIP) {

              if (index === 0) {
                left = 0;
                top = 0;
                width = size.width;
                height = size.height;
                // no way to determine if index 0 was spotted on previous update and not now -> force update
                layersUpdated = true;

                ntleft = 100;
                nttop = 100;
                clipPath = { top: 0, bottom: 0, left: 0, right: 0 }

              } else {
                width = size.width / 5;   // value comes from Zeplin design
                height = width;
                if (videoCount < 5) {
                  left = size.width - (width + 100) * index;
                  clipPath = { top: 5, bottom: 5, left: 5, right: 5 }
                } else {
                  left = size.width - (width * (1 - (videoCount - 4) / 10) + 100) * index - (400 * (videoCount - 4) / 4);
                  const border = width * (videoCount - 4) / 20;
                  clipPath = { top: 5, bottom: 5, left: border * 5.1, right: border * 5.1 };
                }
                top = (size.height - height - 100) - (selectedTicker ? 455 : 0);


                ntleft = left + clipPath.left / 7 + 100;
                nttop = top + height - 450;
              }
            }
          }

          const spottedIndex = producers.findIndex(pr => pr.isSpotted);
          const isHidden = (spottedIndex >= 0 && index !== spottedIndex);
          const producerAttribute = {
            id: p.id,
            name: p.name,
            isHidden,
            top: top / 100,
            left: left / 100,
            width: width / 100,
            height: height / 100,
            clipPath: {
              top: clipPath.top / 100,
              right: clipPath.right / 100,
              bottom: clipPath.bottom / 100,
              left: clipPath.left / 100,
            }
          }
          producerAttributes.push(producerAttribute);


          const layer = {
            number: p.number,
            type: p.type,
            sourceUrl: p.url.indexOf('webrtc') >= 0 ? p.shmUrl : p.url,
            sourceName: p.name,
            sourceId: p.id,
            isHidden: isHidden,
            isSpotted: (index === spottedIndex),
            orderRank: p.orderRank,
            liveRank: p.liveRank,
            position: {
              x: Math.round(left) / 10000,
              y: Math.round(top) / 10000,
              width: Math.round(width) / 10000,
              height: Math.round(height) / 10000,
            },
            crop: {
              top: Math.round(clipPath.top) / 10000,
              left: Math.round(clipPath.left) / 10000,
              right: Math.round(size.width - clipPath.right) / 10000,
              bottom: Math.round(10000 - clipPath.bottom) / 10000,
            },
          };
          layers.push(layer);

          if (nametagsActive && p.type !== ProducerType.CONTENT_SHARING) {

            // console.log('TAG', p.name, ntleft, nttop );

            const pname = p.name || '';
            const pnumber = p.number || 0;
            const nametag = {
              type: 'NAMETAG',
              theme: selectedTheme,
              number: pnumber,
              isVisible: !isHidden,
              animate: false,
              fgColor: '#FFFFFF',
              bgColor: primaryColor,
              borderColor: 'transparent',
              fontFamily: 'Proxima Nova',
              fontWeight: 'normal',
              primaryText: pname,
              secondaryText: '',
              position: {
                x: Math.round(ntleft) / 10000,
                y: Math.round(nttop) / 10000,
              }
            };
            nametags.push(nametag);

          }

          if (!layersUpdated) {

            // console.log('oldlayers2', oldLayers, p);
            const oldLayer = oldLayers.find(old => old.sourceId === layer.sourceId);
            if (oldLayer) {
              if (oldLayer.position.x !== layer.position.x ||
                oldLayer.position.y !== layer.position.y ||
                oldLayer.position.width !== layer.position.width ||
                oldLayer.position.height !== layer.position.height) {
                // console.log('layers updated');
                layersUpdated = true;
              }
            } else {
              layersUpdated = true;
            }
          }

        }
        index++;
      }

    } else {
      layersUpdated = true;
    }
    // set remaining nametags
    const nametag = {
      type: 'NAMETAG',
      theme: selectedTheme,
      number: 0,
      isVisible: false,
      position: { x: 0, y: 0 }
    };
    nametags.push(nametag);

    // console.log('set nametags in store');
    const oldNameTags = templateService.nametags$.getValue();
    templateService.nametags$.next(nametags);
    if (oldNameTags.length !== nametags.length) {
      apiService.forceLayerSend = true;
    }

    if (layers.length !== layersCount) {
      layersUpdated = true;
      setLayersCount(layers.length);
    }

    if (apiService.forceLayerSend) {
      sendUpdatedLayer = true;
      layersUpdated = true;
    }


    displayProducerAttributes();


    // console.log("##### setlayers", layers);
    if (sendUpdatedLayer && layersUpdated) {
      if (!apiService._updateReason || apiService._updateReason.fromUuid === apiService.myUuid) {
        apiService.LAYERSNEXT(layers);
      }
      setTimeout(() => {
        apiService.saveChannel('liveProducers');
      }, 100);
    }

    setTimeout(() => {
      for (const producer of producers) {
        // once video div is created , we can establish stream asso
        if (producer.url.indexOf('webrtc') >= 0) {

          let div = null;
          let divVideo = null;
          if (producer.url.indexOf('webrtc-content-remote') >= 0) {
            // content share
            div = document.getElementById('live-' + producer.url);
            divVideo = document.getElementById(producer.url.indexOf('local') > 0 ? 'localcontentvideo' : 'remotecontentvideo');
          } else if (producer.streamIndex === 0) {
            // local participant
            div = document.getElementById('live-' + producer.url);
            divVideo = document.getElementById('localvideo');
          } else {
            // remote participant
            div = document.getElementById('live-' + producer.url);
            divVideo = document.getElementById('remotevideo' + ('0' + (producer.streamIndex - 1)).slice(-2));
          }
          if (div && divVideo && divVideo.srcObject && div.srcObject !== divVideo.srcObject) {
            // console.log('GIC set srcobject for local');
            div.srcObject = divVideo.srcObject;
          }
        }
      }
    }, 500);



    return true;
  };

  const displayProducerAttributes = () => {

    for (const p of producerAttributes) {

      const li = document.getElementById(p.id);

      console.log(JSON.stringify(p, null, 4))

      if (li) {
        const topProperty = p.top;
        const leftProperty = p.left;
        const widthProperty = p.width + 0.01;
        const heightProperty = p.height + 0.01;

        li.style.setProperty('top', topProperty + '%');
        li.style.setProperty('left', leftProperty + '%');
        li.style.setProperty('width', widthProperty + '%');
        li.style.setProperty('height', heightProperty + '%');
        if (p.clipPath !== null) {
          li.style.setProperty('clip-path', 'inset(' +
            p.clipPath.top + '% ' +
            p.clipPath.right + '% ' +
            p.clipPath.bottom + '% ' +
            p.clipPath.left + '%)');
        } else {
          li.style.setProperty('clip-path', 'unset');
        }
        li.style.setProperty('opacity', p.isHidden ? '0.0' : '1.0');
        li.style.setProperty('pointer-events', p.isHidden ? 'none' : 'all');
      }
    }
  }




  const onToggleSpotted = payload => {
    // console.log('onToggleSpotted callback', payload);
    setSpottedProducer(payload);
  }

  useEffect(() => {
    const handleResize = () => {
      // console.log('Event handleResize called');
      computeWrapperSize(layout.liveControlsVisible);
    };

    window.addEventListener('resize', handleResize);

    // init
    recalculateLayout();
    handleResize();
    setTimeout(() => {
      recalculateLayout();
    }, 1000);

    // console.log('Event handleResize added');
    return () => {
      window.removeEventListener('resize', handleResize);
      // console.log('Event handleResize removed');
    };
  }, [producers, layout.view, layout.liveControlsVisible, selectedTicker]);


  return (
    <ul className='LivePreview-list'>
      {producers.map((p: Producer) => (
        <li key={p.id} id={p.id}
          draggable
          onDragOver={(e) => OnDragOver(e, p)}
          onDragStart={(e) => OnDragStart(e, p)}
          onDragEnd={(e) => OnDragEnd(e)}
          onDragLeave={(e) => OnDragLeave(e)}
          onDrop={(e) => OnDrop(e, p)}
          style={{ width: '0', height: '0', left: '2000px', top: '0' }}
        >
          <ProducerLivePlayer
            producer={p}
            name={p.name}
            isSpotted={p.isSpotted}
            audioMute={p.audioMute}
            videoMute={p.videoMute}
            initials={getInitials(p.name)}
            url={p.url}
            onToggleSpotted={(isSpotted) => onToggleSpotted({ producer: p, isSpotted })}
          ></ProducerLivePlayer>
        </li>)
      )
      }
    </ul>
  );
});

const sortOnliveRank = (a: Producer, b: Producer) => {
  if (a.liveRank < b.liveRank) { return -1; }
  if (a.liveRank > b.liveRank) { return 1; }
  // if (a.orderRank > b.orderRank) { return 1; }
  // if (a.orderRank < b.orderRank) { return -1; }
  return 0;
};


export const LiveProducers = () => {

  const [apiService] = useState(container.resolve(ApiService));


  const producers = useSelector((state: any) => state.producers);

  const [liveProducers, setLiveProducers] = useState([]);

  useEffect(() => {

    // get live producers
    let liveProducers = producers.filter(p => p.isLive);

    // sort be live rank
    liveProducers.sort(sortOnliveRank);

    // show at max 9 producer
    setLiveProducers(liveProducers.slice(0, 9));

    // console.log("%%%% LiveProducerView producers=", producers, liveProducers);
  }, [producers])


  return (
    <>
      {apiService.myUuid &&
        <ShowProducers producers={liveProducers}></ShowProducers>
      }
    </>
  )
}

export const LiveProducerView = (props) => {

  return (
    <div className='LivePreview-viewer' id='LivePreview-viewer'>
      <Backgrounds></Backgrounds>
      <LiveProducers></LiveProducers>
      <IFrame></IFrame>
      <Foregrounds></Foregrounds>
      {/* <SharedVideo></SharedVideo> */}
    </div>
  )

};
